<template>
  <div :class="settingPanel ? 'mobile-search-comp' : 'search-comp'">
    <el-input placeholder="输入关键字搜索" v-model="searchText" class="input-with-select input-style" :size="settingPanel ? 'mini' : 'medium'">
      <el-select
        class="select-style"
        v-model="selectValue"
        slot="prepend"
        @change="queryTypeChange"
        placeholder="请选择">
        <el-option
          v-for="(value, index) in selectArr"
          :key="index"
          :label="value.value"
          :value="value.key">{{value.value}}</el-option>
      </el-select>
      <el-button class="button-style" slot="append" icon="el-icon-search" @click="selectResult"></el-button>
    </el-input>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "searchComp",
  computed: {
    ...mapGetters([
      'queryType',
      'queryValue'
    ]),
    settingPanel(){
      return this.$store.state.app.device === 'mobile'
    },
  },
  data () {
    return {
      searchText: '',
      selectValue: 1,
      selectArr: [
        {value: '来源', key: 4},
        {value: '标题', key: 1},
        {value: '关键词', key: 3},
        {value: '全文', key: 2}
      ]
    }
  },
  methods: {
    queryTypeChange (val) {
      this.$store.commit('industry/SET_QUERYTYPE', val)
    },
    selectResult () {
      this.$store.commit('industry/SET_QUERYTYPE', this.selectValue)
      this.$store.commit('industry/SET_QUERYVALUE', this.searchText)
      if (this.$route.fullPath !== '/selectResult') {
        this.$router.push({path: '/selectResult'})
      }
      else {
        this.$store.commit('industry/SET_FINDVALUE')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-comp{
  >>> .select-style{
    width: p2r(80px);
    font-size: 12px;
  }
  .input-style{
    width: p2r(408px);
  }
}
.mobile-search-comp{
  >>> .select-style{
    width: p2r(75px);
    font-size: p2r(12px);
  }
  .input-style{
    width: p2r(210px);
  }
}
</style>
<style lang="scss">
.search-comp, .mobile-search-comp{
  .select-style{
    .el-input--suffix {
      .el-input__inner {
        padding-right: p2r(24px);
      }
    }
    .el-select__caret {
      color: #333333;
    }
  }
  .input-with-select{
    .el-input__inner{
      border-color: $bloodRed;
      border-left: 0;
    }
  }
  .el-input-group__append{
    background: $bloodRed;
    color: #ffffff;
    border-color: $bloodRed;
    text-align: center;
    .el-button{
      padding-right: p2r(8px);
      padding-left: p2r(8px);
    }
  }
  .el-input-group__prepend{
    background: #ffffff;
    color: #333333;
    border-color: $bloodRed;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      width: 1px;
      height: 100%;
      right: 0;
      top: 0;
      background: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/searchComp.vue